import { useSearchParams } from 'react-router-dom';
import { groupByCategory } from '@platform/navigation';

/**
 * Стан сторінки «Усі модулі» в адресі: ?group= (ключ групи, pinned, system) або ?cat= (категорія каталогу — посилання крихт шапки сторінок
 * модулів) і ?q= (пошук модулів); його спільно читають ліва колонка категорій і сторінка. Зміна фільтра записує ключ групи (?group=).
 */
export function useModulesQuery(): { group: string; q: string; setGroup: (group: string) => void; setQ: (q: string) => void } {
  const [params, setParams] = useSearchParams();
  const group = params.get('group') ?? groupByCategory(params.get('cat'))?.key ?? '';
  const q = params.get('q') ?? '';
  const write = (next: Record<string, string>) => {
    const out = new URLSearchParams();
    Object.entries({ group, q, ...next }).forEach(([k, v]) => { if (v) out.set(k, v); });
    setParams(out, { replace: true });
  };
  return { group, q, setGroup: (g) => write({ group: g }), setQ: (text) => write({ q: text }) };
}
